import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-tag',
  templateUrl: './m-tag.component.html',
  styleUrls: ['./m-tag.component.scss'],
  imports: [NgClass]
})
export class MTagComponent {
  @Input() isDark = false;
  @Input() isPositive = true;
  @Input() isUp = true;
  @Input() isNeutral = false;
  @Input() showBackground = true;
}
